import React, { useEffect, useRef, useState } from "react";
import {
  FormControl,
  InputAdornment,
  Stack,
  TextareaAutosize,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import CheckBox from "../../../../styles/svg/id-icon.svg";
import { useResponsive } from "../../../../hooks/useResponsive";
import { CustomButton } from "../../../../components/Button/Button";

function FieldCreateEditCard({
  handleKeyDown,
  setTitle,
  setCreateBtnOpen,
  edit = false,
  value,
  minRows = 3,
  className = "create-card-textarea",
  ref = null,
  setOpenCreateSubtask,
}) {
  const [error, setError] = useState(false);
  const isMobile = useResponsive("down", "md");
    const textareaRef = useRef(null);

  const handleChange = (event) => {
    const value = event.target.value.trimStart();
    setTitle(value);
    if (value.length <= 255) {
      setError(false);
    } else {
      setError(true);
    }
  };

  useEffect(() => {
      if (textareaRef.current) {
        requestAnimationFrame(() => {
          const length = textareaRef.current.value.length;
          textareaRef.current.setSelectionRange(length, length); // Move cursor to end
          textareaRef.current.focus(); // Ensure focus
        });
      }
    }, []);

  return (
    <FormControl fullWidth onClick={(e) => e.stopPropagation()} ref={ref}>
      <TextareaAutosize
        aria-label="empty textarea"
        placeholder="What needs to be done?"
        minRows={minRows} // Set the minimum number of rows
        className={`${className} ${error ? "create-card-error-textarea" : ""}`}
        // defaultValue={value}
        value={value}
        onKeyDown={handleKeyDown}
        onChange={handleChange}
        onBlur={
          isMobile
            ? () => {
                "";
              }
            : setCreateBtnOpen
        }
        autoFocus
        ref={textareaRef}
      />

      {!edit && (
        <InputAdornment position="end">
          <Stack
            direction={"row"}
            justifyContent={"space-between"}
            width={"100%"}
          >
            <Stack direction={"row"}>
              <img src={CheckBox} alt="checkbox" className=" mb-6" />
              <ExpandMoreIcon
                className="mb-6"
                onClick={() => setOpenCreateSubtask(false)}
              />
            </Stack>
            {isMobile && (
              <CustomButton
                className="mb-6 mr-2 edit-card-submit-btn"
                sx={{
                  color: "white",
                  backgroundColor: "rgb(37, 150, 190)",
                  padding: "0px",
                  fontSize: "12px",
                }}
                onClick={(event) => {
                  handleKeyDown({ ...event, key: "btnClicked" });
                }}
              >
                Done
              </CustomButton>
            )}
          </Stack>
        </InputAdornment>
      )}
      {error && (
        <Typography
          variant="body2"
          color="error"
          className="card-error-font-size"
        >
          Character limit exceeded! Maximum 255 characters allowed.
        </Typography>
      )}
    </FormControl>
  );
}

export default FieldCreateEditCard;
